import { useLocation } from 'react-router-dom'
import { useI18n } from '@runtime/core/i18n/i18n'
import GameCommandIcon from '@/components/gameCommands/GameCommandIcon'
import { isUpdateSafePath } from './updateSafety'
import { usePwaUpdateStore } from './pwaUpdateStore'
export default function PwaUpdateAction() {
  const { t } = useI18n()
  const { pathname } = useLocation()
  const available = usePwaUpdateStore(state => state.available)
  const open = usePwaUpdateStore(state => state.open)
  if (!available || !isUpdateSafePath(pathname)) return null
  return (
    <button type="button" data-testid="pwa-update-open" onClick={open}>
      <GameCommandIcon kind="restart" />
      <span>{t('runtime.pwaUpdate.open')}</span>
    </button>
  )
}
